<template>
  <div>
    <v-textarea
      v-model="formData.nationality"
      :disabled="disabled"
      :label="$t('Persona a la que sustituye')"
      :rules="[rules.required]"
      required
      box
    ></v-textarea>
    <v-textarea
      v-model="formData.sustitucion_motivo"
      :disabled="disabled"
      :label="$t('Motivo de la sustitución')"
      :rules="[rules.required]"
      required
      box
    ></v-textarea>

    <og-simple-date-input
      v-model="formData.sustitucion_fecha_fin"
      :disabled="disabled"
      :label="$t('Fecha fin de contrato de interinidad/sustitución')"
      required
    ></og-simple-date-input>
  </div>
</template>

<script>
import OgSimpleDateInput from '@/components/commons/form/inputs/OgSimpleDateInput.vue';

export default {
  components: { OgSimpleDateInput },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          sustitucion_persona_a_sustituir: null,
          sustitucion_motivo: null,
          sustitucion_fecha_fin: null,
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
